import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ShoppingCartIcon, SparklesIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Descargás el Plan',
    description: 'Recibís el PDF al instante en tu celular o mail apenas completás el pago.',
    icon: DownloadIcon
  }, {
    number: '2',
    title: 'Hacés el súper',
    description: 'Usás la lista optimizada para tu presupuesto en el mercado de tu barrio.',
    icon: ShoppingCartIcon
  }, {
    number: '3',
    title: 'Sentís el cambio',
    description: 'Aplicás el switch de 24 horas y notás la diferencia desde el primer día.',
    icon: SparklesIcon
  }];
  return <section className="py-24 px-4 bg-cream relative" data-id="element-51">
      <div className="max-w-5xl mx-auto" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-53">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-54">
            ¿Cómo funciona?
          </h2>
          <p className="text-lg text-brown/70" data-id="element-55">
            Simple, rápido y sin complicaciones.
          </p>
        </motion.div>

        <div className="relative" data-id="element-56">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-sage/20 -translate-y-1/2 z-0" data-id="element-57" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-58">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-59">
                <div className="w-20 h-20 bg-white rounded-full shadow-md border-4 border-cream flex items-center justify-center mb-6 relative group-hover:scale-110 transition-transform duration-300" data-id="element-60">
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-terracotta text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-61">
                    {step.number}
                  </div>
                  <step.icon className="w-8 h-8 text-sage" data-id="element-62" />
                </div>
                <h3 className="text-2xl font-serif font-bold mb-3" data-id="element-63">
                  {step.title}
                </h3>
                <p className="text-brown/80 text-lg" data-id="element-64">{step.description}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}